import { IPoll } from "./types/poll.types";
import LoadingSkeleton from "../common/loading-skeleton/loading-skeleton";
import {
    Ban,
    ChartColumnBig,
    CircleCheckBig,
    Vote
} from "lucide-react";
import EmptyData from "../common/empty-data/empty-data";
import StatCards, { StatCardColor } from "../common/stat-cards/stat-cards";
import React from "react";
import PollToolbar from "./utils/poll-toolbar";

interface PollViewProps {
    polls: IPoll[],
    loadingPolls: boolean,
    handleOnClick: (id: string) => void;
    onFilterChange: (type: string) => void;
    fetchPolls: (payload: any) => void;
    handleDateChange: (range: { startDate: string, endDate: string }) => void;
}

const PollAdminView = (props: PollViewProps) => {

    const totalPolls = props.polls.length
    const activePollsCount = props.polls.filter((item: IPoll) => item.active).length;
    const inactivePollsCount = totalPolls - activePollsCount;

    const cardData = [
        {
            key: 'total',
            label: 'Total',
            value: totalPolls,
            icon: ChartColumnBig,
            color: 'brown' as StatCardColor
        }, {
            key: 'active',
            label: 'Active',
            value: activePollsCount,
            icon: CircleCheckBig,
            color: 'green' as StatCardColor
        }, {
            key: 'inactive',
            label: 'Inactive',
            value: inactivePollsCount,
            icon: Ban,
            color: 'red' as StatCardColor
        },
    ];

    return (
        <>
            <div className={'poll-stats-card-container'}>
                <StatCards data={cardData} size={'small'} loading={props.loadingPolls}/>
            </div>
            <PollToolbar onFilterChange={props.onFilterChange} fetchPolls={props.fetchPolls}
                         handleDateChange={props.handleDateChange}/>
            <LoadingSkeleton loading={props.loadingPolls}>
                {props.polls.length > 0 ? (
                    <div className={'poll-container'}>
                        {props.polls.map((item: IPoll) => (
                            <div className={`poll ${item.anonymous ? "vote" : "poll"}`} key={item.id}
                                 onClick={() => props.handleOnClick(item.id)}>
                                <div className={'poll-status'}>
                                    <span className={`status ${item.anonymous ? "voting" : "polling"}`}>
                                        {item.anonymous ? "Vote" : "Poll"}
                                    </span>
                                    <span
                                        className={`status ${item.anonymous || !item.showVoters ? "anonymous" : "non-anonymous"}`}>
                                        {item.anonymous ? "Anonymous" : item.showVoters ? "Non-Anonymous" : "Anonymous"}
                                    </span>
                                    <span className={`status ${item.anonymous ? "results-after" : "results-live"}`}>
                                        {item.anonymous ? "Results After Close" : "Results Live"}
                                    </span>
                                    <span className={`status ${item.active ? "active" : "ended"}`}>
                                        {item.active ? "Active" : `${item.anonymous ? "Voting Ended" : "Poll Ended"}`}
                                    </span>
                                </div>
                                <div className={'poll-heading'}>
                                    <div className={'vote-icon'}>
                                        <Vote/>
                                    </div>
                                    <h5>{item.title}</h5>
                                </div>
                                <div className={'poll-description'}
                                     dangerouslySetInnerHTML={{__html: item.description}}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="poll-empty-container">
                        <EmptyData
                            icon={<ChartColumnBig className={'empty-data-poll-icon'}/>}
                            title="No Polls Available"
                            subtitle={"There are no polls to display at the moment. Create a new poll to start collecting responses."}
                        />
                    </div>
                )}
            </LoadingSkeleton>
        </>
    )
}

export default PollAdminView;
